import React, { useEffect, useState } from "react";
import { Menu, Button, Select } from "semantic-ui-react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import axiosInstance from "../../api/axiosInstance";
import { PDFPreview } from "../../component/pdfView";
import { useHistory } from "react-router";
import { sendNotification } from "../../utils/firebase";

const Approval = () => {
  const sideMenus = [
    // { label: "Anggaran", url: "/anggaran" },
    { label: "Arus Kas", url: "/arus-kas" },
    { label: "Laba Rugi", url: "/laba-rugi" },
    { label: "Neraca", url: "/neraca" },
    { label: "Dokumen", url: "/document" },
  ];
  const history = useHistory();
  const topMenus = ["All", "Pending", "Approved", "Rejected"];
  const [sideMenuActive, setSideMenuActive] = useState(sideMenus[0]);
  const [topMenuActive, setTopMenuActive] = useState(0);
  const [data, setData] = useState([]);
  const [loadingApi, setLoadingApi] = useState(true);
  const [toApprove, setToApprove] = useState(null);
  const [toReject, setToReject] = useState(null);
  const [toCancelApproval, setToCancelApproval] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [pdfOpen, setPdfOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState({});
  const d = new Date();
  const [year, setYear] = useState(d.getFullYear());
  const [yearOpt, setYearOpt] = useState([]);
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const [notificationData, setNotificationData] = useState({})

  const months = [
    "",
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  const status = [
    { className: "badge badge-warning", text: "Pending" },
    { className: "badge badge-warning", text: "Pending" },
    { className: "badge badge-success", text: "Approved" },
    { className: "badge badge-danger", text: "Rejected" },
  ];

  const pdfTypes = ["", "Laporan Keuangan", "Laporan Kinerja", "Laporan Lainnya"];

  const changeSideMenu = (e, menu) => {
    e.preventDefault();
    if (menu === sideMenuActive) return;
    else {
      setSideMenuActive(menu);
      loadData(menu.url, topMenuActive, year);
    }
  };

  const loadData = async (url, path, year) => {
    setLoadingApi(true);
    try {
      const res = await axiosInstance.get(`${url}/status${path > 0 ? "/" + path : ""}?year=${year}`);
      setData(res.data.content);
    } catch (err) { }
    setLoadingApi(false);
  };

  const loadYearOpt = () => {
    let opt = [];
    for (let i = 2017; i <= year; i++) {
      opt.push({ text: i, value: i });
    }
    setYearOpt(opt);
  };

  const handleChangeYear = (e, { value }) => {
    setYear(value);
    loadData(sideMenuActive.url, topMenuActive, value);
  };

  const changeTopMenu = (e, menu) => {
    e.preventDefault();
    if (menu === topMenuActive) return;
    else {
      setTopMenuActive(menu);
      loadData(sideMenuActive.url, menu, year);
    }
  };

  const approve = async () => {
    let isError = false;
    setBtnLoading(true);
    try {
      await axiosInstance.put(`${sideMenuActive.url}/approve/${toApprove}`);
    } catch (err) {
      isError = true
    } finally {
      if (!isError && notificationData) {
        sendNotification(`Laporan Bulanan ${notificationData.laporan}`,
          `Laporan Bulanan ${notificationData.laporan} ${notificationData.perusahaan} telah di upload`,
          user?.role === 4 ? "approval" : null)
      }
      setConfirmDialog(null);
      await loadData(sideMenuActive.url, topMenuActive, year);
      setBtnLoading(false);
    }
  };

  const reject = async () => {
    setBtnLoading(true);
    try {
      await axiosInstance.put(`${sideMenuActive.url}/reject/${toReject}`);
    } catch (err) {
    } finally {
      setConfirmDialog(null);
      await loadData(sideMenuActive.url, topMenuActive, year);
      setBtnLoading(false);
    }
  };

  const cancelApproval = async () => {
    setBtnLoading(true);
    try {
      await axiosInstance.put(`${sideMenuActive.url}/cancel-approval/${toCancelApproval}`);
    } catch (err) {
    } finally {
      setConfirmDialog(null);
      await loadData(sideMenuActive.url, topMenuActive, year);
      setBtnLoading(false);
    }
  };

  const openApprove = (data) => {
    setNotificationData({
      laporan: sideMenuActive.label,
      bulan: data.month,
      perusahaan: data.perusahaan?.nama
    })
    setToApprove(data.id);
    setConfirmDialog("approve");
  };

  const openReject = (id) => {
    setToReject(id);
    setConfirmDialog("reject");
  };

  const openCancelApproval = (id) => {
    setToCancelApproval(id);
    setConfirmDialog("cancel-approval");
  };

  useEffect(() => {
    loadYearOpt();
    loadData(sideMenuActive.url, topMenuActive, year);
  }, []);

  const openDetail = (url, d) => {
    localStorage.setItem(url, JSON.stringify(d));
    history.push(url);
  };

  return (
    <>
      <div className="card border-0 rounded-0">
        <div className="container py-4">
          <div className="row px-4">
            <div className="col-md-4 d-flex align-items-center ">
              <h3 className="mr-auto my-auto">Daftar Approval</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="container mt-3">
        <div className="card container shadow-sm border-0">
          <div className="row">
            <div className="col-3 py-3 border-right">
              <Menu className="w-100" vertical secondary inverted>
                {sideMenus.map((menu) => (
                  <a
                    href="/#"
                    className={`blue item ${menu.label === sideMenuActive.label ? "active" : ""}`}
                    onClick={(e) => changeSideMenu(e, menu)}
                  >
                    {menu.label}
                  </a>
                ))}
              </Menu>
            </div>
            <div className="col-9 py-3">
              <Menu pointing secondary className="menu--top">
                {topMenus.map((menu, index) => (
                  <a
                    href="/#"
                    key={menu}
                    className={`green item ${index === topMenuActive ? "active" : ""}`}
                    onClick={(e) => changeTopMenu(e, index)}
                  >
                    {menu}
                  </a>
                ))}
              </Menu>
              <div className="mb-2 clearfix">
                <div className="float-right">
                  <span className="d-inline-block mr-2">Tahun</span>
                  <Select className={`input--years`} options={yearOpt} value={year} onChange={handleChangeYear} />
                </div>
              </div>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Bulan</th>
                    <th>Created By</th>
                    {sideMenuActive.label === "Dokumen" && <th>Tipe</th>}
                    <th>
                      {topMenuActive === 0 || topMenuActive === 1
                        ? "Status"
                        : topMenuActive === 2
                          ? "Approved By"
                          : "Rejected By"}
                    </th>
                    <th width="200">Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {loadingApi ? (
                    <tr>
                      <td colSpan={sideMenuActive.label === "Dokumen" ? "5" : "4"} align="center">
                        Loading...
                      </td>
                    </tr>
                  ) : data.length === 0 ? (
                    <tr>
                      <td colSpan={sideMenuActive.label === "Dokumen" ? "5" : "4"} align="center">
                        <em>Data tidak ada</em>
                      </td>
                    </tr>
                  ) : (
                    data
                      .sort((a, b) => a.month - b.month)
                      .map((d) => (
                        <tr>
                          <td>{months[d.month]}</td>
                          <td>{d.createdBy?.name ?? "-"}</td>
                          {sideMenuActive.label === "Dokumen" && <th>{pdfTypes[d.type]}</th>}
                          <td>
                            {topMenuActive === 0 || topMenuActive === 1 ? (
                              <span className={status[d.status].className}>{status[d.status].text}</span>
                            ) : topMenuActive === 2 ? (
                              d.approvedBy?.name ?? "-"
                            ) : (
                              d.rejectedBy?.name ?? "-"
                            )}
                          </td>
                          <td>
                            {sideMenuActive.label === "Dokumen" ? (
                              <button
                                className="btn btn-sm mr-1 btn-secondary"
                                onClick={() => {
                                  setSelectedPdf(d);
                                  setPdfOpen(true);
                                }}
                              >
                                Preview
                              </button>
                            ) : (
                              <button
                                className="btn btn-sm mr-1 btn-secondary"
                                onClick={() => openDetail(`/approval${sideMenuActive.url}/detail`, d)}
                              >
                                Detail
                              </button>
                            )}
                            {d.status !== 2 && d.status !== 3 && (
                              <>
                                <button className="btn btn-sm mr-1 btn-success" onClick={() => openApprove(d)}>
                                  Approve
                                </button>
                                <button className="btn btn-sm btn-danger" onClick={() => openReject(d.id)}>
                                  Reject
                                </button>
                              </>
                            )}
                            {d.status !== 1 && d.status === 2 && (
                              <button className="btn btn-sm mr-1 btn-info" onClick={() => openCancelApproval(d.id)}>
                                Cancel Approval
                              </button>
                            )}
                          </td>
                        </tr>
                      ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={confirmDialog === "approve"} toggle={() => setConfirmDialog(null)}>
        <ModalHeader toggle={() => setConfirmDialog(null)}>Konfirmasi</ModalHeader>
        <ModalBody>Apakah anda yakin akan approve {sideMenuActive.label} ini?</ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setConfirmDialog(null)}>
            Tidak
          </Button>
          <Button color="green" onClick={approve} loading={btnLoading}>
            Ya
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={confirmDialog === "reject"} toggle={() => setConfirmDialog(null)}>
        <ModalHeader toggle={() => setConfirmDialog(null)}>Konfirmasi</ModalHeader>
        <ModalBody>Apakah anda yakin akan reject {sideMenuActive.label} ini?</ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setConfirmDialog(null)}>
            Tidak
          </Button>
          <Button color="red" onClick={reject} loading={btnLoading}>
            Ya
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={confirmDialog === "cancel-approval"} toggle={() => setConfirmDialog(null)}>
        <ModalHeader toggle={() => setConfirmDialog(null)}>Konfirmasi</ModalHeader>
        <ModalBody>Apakah anda yakin akan cancel approval {sideMenuActive.label} ini?</ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setConfirmDialog(null)}>
            Tidak
          </Button>
          <Button color="red" onClick={cancelApproval} loading={btnLoading}>
            Ya
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={pdfOpen} toggle={() => setPdfOpen(!pdfOpen)} size="lg">
        <ModalHeader toggle={() => setPdfOpen(!pdfOpen)}>{selectedPdf.name}</ModalHeader>
        <ModalBody style={{ "max-height": "calc(100vh - 210px)" }}>
          <PDFPreview doc={selectedPdf} />
        </ModalBody>
      </Modal>
    </>
  );
};

export default Approval;
